import React from "react";
import { Box, Typography, Container } from "@mui/material";

export default function FAQSection() {
  const faqData = [
    {
      id: 1,
      question: "What is AI Skill Insights?",
      answer:
        "AI Skill Insights is a smart tool that helps you discover sub-skills, enterprise adoption rates, career role suggestions, and recommended learning paths for your chosen skill.",
    },
    {
      id: 2,
      question: "How do I find sub-skills for my skill?",
      answer:
        "Simply enter your skill in the search box, and our system will instantly show related sub-skills along with relevant skills in your field.",
    },
    {
      id: 3,
      question: "What is enterprise adaptation percentage?",
      answer:
        "Enterprise adaptation percentage tells you how widely your skill is adopted in the corporate world, giving you insights into its market demand.",
    },
    {
      id: 4,
      question: "What is the Learn & Earn Recommendation?",
      answer:
        "The Learn & Earn feature shows you how much value a new skill can add to your career and potential earning growth after mastering it.",
    },
    {
      id: 5,
      question: "How do you suggest career roles?",
      answer:
        "Based on your entered skill our AI suggests the most relevant roles in your industry along with possible career paths.",
    },
    {
      id: 6,
      question: "Can I see other roles and responsibilities for a skill?",
      answer:
        "Yes, we provide a list of additional roles and responsibilities linked to your skill so you can explore diverse career opportunities.",
    },
    {
      id: 7,
      question: "How do you recommend courses?",
      answer:
        "We suggest skill-based courses from trusted platforms like YouTube, Google Search, Google Gemini, and ChatGPT learning resources.",
    },
    {
      id: 8,
      question: "Is AI Skill Insights free to use?",
      answer:
        "Yes, the basic version is free, and you can explore skills, sub-skills, roles, and suggested courses without any payment.",
    },
    {
      id: 9,
      question: "Can this tool help me choose a new career path?",
      answer:
        "Absolutely! By analyzing your current skills and market trends, we recommend roles, responsibilities, and learning resources to help you transition smoothly.",
    },
    {
      id: 10,
      question: "How often is the skill data updated?",
      answer:
        "Our database is updated regularly to ensure you get the latest enterprise adoption rates, career trends, and learning recommendations.",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#000",
        minHeight: "100vh",
        color: "#ffffff",
        py: { xs: 2, sm: 4, md: 6, lg: 8 },
        px: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          maxWidth: "100%",
          margin: "0 auto",
          px: "0px !important",
          mx: {
            xs: 0,
            sm: "50px",
            md: "100px",
            lg: "224px",
          },
        }}
      >
        {/* FAQ Title */}
        <Typography
          variant="h1"
          sx={{
            color: "#fff",
            fontFamily: "'SF Pro Display', 'Inter', sans-serif",
            fontWeight: 600,
            fontStyle: "bold",
            fontSize: { xs: "28px", sm: "36px", md: "44px", lg: "56px" },
            lineHeight: { xs: "35px", sm: "45px", md: "55px", lg: "70px" },
            textAlign: "center",
            mb: { xs: 3, sm: 4, md: 5, lg: 6 },
          }}
        >
          FAQs
        </Typography>

        {/* FAQ Content Container */}
        <Box
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            borderRadius: "20px",
            p: { xs: 2, sm: 3, md: 4 },
            border: "1px solid rgba(255, 255, 255, 0.1)",
          }}
        >
          {faqData.map((item) => (
            <Box
              key={item.id}
              sx={{
                backgroundColor: "rgba(255, 255, 255, 0.06)",
                borderRadius: "8px",
                mb: { xs: 1.5, sm: 2 },
                p: { xs: 1.5, sm: 2, md: 2.5 },
                transition: "background-color 0.2s ease",
                cursor: "default",
                "&:hover": {
                  backgroundColor: "#242424",
                },
              }}
            >
              {/* Question */}
              <Typography
                sx={{
                  color: "#ffffff",
                  fontFamily: "'SF Pro Display', 'Inter', sans-serif",
                  fontWeight: 400,
                  fontStyle: "normal",
                  fontSize: { xs: "16px", sm: "18px", md: "20px" },
                  lineHeight: { xs: "22px", sm: "25px", md: "28px" },
                  mb: { xs: 1, sm: 1.25 },
                }}
              >
                {item.id}. {item.question}
              </Typography>

              {/* Answer */}
              <Typography
                sx={{
                  color: "#b3b3b3",
                  fontFamily: "'SF Pro Display', 'Inter', sans-serif",
                  fontWeight: 400,
                  fontStyle: "normal",
                  fontSize: { xs: "14px", sm: "15px", md: "16px" },
                  lineHeight: { xs: "20px", sm: "23px", md: "26px" },
                  margin: "0",
                }}
              >
                {item.answer}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
